import React, { useEffect, useState } from 'react';
import { 
  Box,
  Button,
  Flex,
  Text,
  useToast,
  SimpleGrid,
  Stack,
  Menu,
  MenuButton,
  MenuList,
  MenuItem, 
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Input
} from '@chakra-ui/react';
import { cqAPI } from "../../lib/Auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown
} from '@fortawesome/free-solid-svg-icons';
import moment from 'moment'; // Assuming you use moment for date formatting

function Whitelist() {
  const [whitelist, setWhitelist] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [entry, setEntry] = useState({ type: 'email', value: '' });
  const toast = useToast();

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneNumberRegex = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;

  const fetchWhitelist = async () => {
    try {
      const response = await cqAPI.get('/whitelist');
      setWhitelist(response.data);
    } catch (error) {
      console.error('Error fetching whitelist:', error);
    }
  };

  useEffect(() => {
    fetchWhitelist();
  }, []);

  const addToWhitelist = async (entry) => {
    try {
      const response = await cqAPI.post('/whitelist', { ...entry });
      if (response.type === 'ok') {
        toast({ title: "Entry added successfully", status: "success" });
        setIsOpen(false); // Close modal after adding
        fetchWhitelist(); // Refresh the whitelist
        setEntry({ type: 'email', value: '' }); // Clear the input field after successful addition
      } else {
        toast({ title: "Error adding entry", description: response.msg, status: "error" });
      }
    } catch (error) {
      toast({ title: "Error adding entry", description: error.message, status: "error" });
    }
  };

  const removeFromWhitelist = async (id) => {
    console.log('deleting', id)
    try {
      const response = await cqAPI.del('/whitelist', { id });
      if (response.type === 'ok') {
        toast({ title: "Entry removed successfully", status: "success" });
        fetchWhitelist(); 
      } else {
        toast({ title: "Error removing entry", description: response.msg, status: "error" });
      }
    } catch (error) {
      toast({ title: "Error removing entry", description: error.message, status: "error" });
      console.error('Error removing entry:', error);
    }
  };

  const onClose = () => setIsOpen(false);
  const onOpen = () => setIsOpen(true);
  const handleAddToWhitelist = () => {
    if (entry.type === 'email' && !emailRegex.test(entry.value)) {
      toast({
        title: "Invalid email",
        description: "Please enter a valid email address.",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } else if (entry.type === 'phone' && !phoneNumberRegex.test(entry.value)) {
      toast({
        title: "Invalid phone number",
        description: "Please enter a valid phone number.",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } else {
      addToWhitelist(entry); // Call your existing addToWhitelist function
    }
  };

  return (
    <Box p={4} maxHeight="100vh" width="100%" position="relative">
      <Flex justifyContent="flex-end" mb={4}>
        <Menu>
          <MenuButton as={Button} onClick={onOpen}>
            Add to whitelist
          </MenuButton>
        </Menu>
      </Flex>  

      {/* Modal for adding to whitelist */}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add to whitelist</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Stack spacing={3}>
              <Menu>
                <MenuButton as={Button} rightIcon={<FontAwesomeIcon icon={faChevronDown} />}>
                  {entry.type === 'email' ? 'Email' : 'Phone'}
                </MenuButton>
                <MenuList>
                  <MenuItem onClick={() => setEntry({ ...entry, type: 'email' })}>Email</MenuItem>
                  <MenuItem onClick={() => setEntry({ ...entry, type: 'phone' })}>Phone</MenuItem>
                </MenuList>
              </Menu>
              <Input 
                placeholder={entry.type === 'email' ? "Enter email" : "Enter phone number"} 
                value={entry.value}
                onChange={(e) => setEntry({ ...entry, value: e.target.value })}
              />
            </Stack>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleAddToWhitelist}>
              Add
            </Button>
            <Button variant="ghost" onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>    

      <Box p={4} overflowY="auto" maxHeight="95vh" width="100%" position="relative">
        <SimpleGrid columns={{ base: 1, md: 3, lg: 1 }} spacing="20px">
          {Array.isArray(whitelist) && whitelist.map(({ _id, type, value, created }) => (
            <Box key={_id} borderWidth="1px" borderRadius="lg" mb={4} width="100%">
              <Flex direction="column" p={4} justify="space-between" height="100%">
                <Flex justify="space-between" align="right" textAlign="left">
                  <Box>
                    <Text fontSize="sm"> <b>{type.charAt(0).toUpperCase() + type.slice(1)}:</b> {value}</Text>
                    <Text fontSize="sm"> <b>Added on:</b> {moment(created).format('MMMM Do YYYY, h:mm:ss a')}</Text>
                  </Box>
                  <Button colorScheme="blue" onClick={() => removeFromWhitelist(_id)}>
                    Remove
                  </Button>
                </Flex>
              </Flex>
            </Box>
          ))}
        </SimpleGrid>
      </Box>
    </Box>
  );
}

export default Whitelist;
